export default __webpack_public_path__ + "static/media/plus-resale.12cdfc17.svg";